import { Loader } from '@mantine/core';

import classes from './LabeledLoader.module.css';

export interface LabeledLoaderProps {
  label: string;
}

export function LabeledLoader({ label }: LabeledLoaderProps) {
  return (
    <div className={classes.loading}>
      <div className={classes.loader}>
        <Loader color="dark.2" size="xs" />
        <div>{label}</div>
      </div>
    </div>
  );
}
